
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5397',
  depVersions: {
  "data-privacy-request-ui": "static-1.5397",
  "data-fetching-client": "static-1.9549",
  "head-dlb": "static-1.4884",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7883",
  "hub-http-shared-msw-handlers": "static-1.9655",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11316",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6343",
  "privacy-center-public-service-types": "static-1.4660",
  "quartz": "static-1.6831",
  "react-dlb": "static-1.74",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5454",
  "UIComponents": "static-3.8263",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.83",
  "foundations-assets": "static-1.4713",
  "foundations-components": "static-1.7662",
  "foundations-components-test-utils": "static-1.5145",
  "foundations-theming": "static-1.4283",
  "hub-http": "static-1.6092",
  "quartz-config": "static-1.609",
  "quartz-core": "static-1.6050",
  "quick-fetch": "static-1.3807",
  "raven": "static-3.5768",
  "react": "static-7.182",
  "react-rhumb": "static-1.16525",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11020",
  "usage-tracker": "static-1.7210",
  "usage-tracker-anonymous": "static-1.5627",
  "usage-tracker-core": "static-1.7060",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3957",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3301",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3108",
  "quartz-webpack": "static-1.3055",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.79",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.69",
  "hs-test-utils-bend-plugin": "static-1.2994",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "ts-schema": "static-1.3974",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "react-utils": "static-2.5242",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4198",
  "rpc-client-utils": "static-1.4517",
  "HubStyle": "static-2.11624",
  "ui-addon-draggable": "static-3.4641",
  "cssUtils": "static-1.764",
  "hs-story-utils": "static-1.9300",
  "icons": "static-2.637",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.96",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-components": "static-1.3931",
  "floating-ui": "static-1.53",
  "foundations-theming-specialty": "static-1.1999",
  "react-aria": "static-1.63",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1424",
  "ui-fonts": "static-1.578",
  "foundations-components-legacy": "static-1.687",
  "bend-plugin-foundations-theming": "static-1.2766",
  "foundations-theming-base": "static-1.3268",
  "stylex": "static-1.29",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4547",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.506",
  "quartz-head": "static-1.496",
  "quartz-i18n": "static-1.506",
  "quartz-routing": "static-1.261",
  "quartz-test": "static-1.506",
  "quartz-tracking": "static-1.210",
  "usage-tracker-container": "static-1.7200",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3025",
  "chirp-fetch": "static-1.1756",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.67",
  "sassPrefix": "static-1.153",
  "hubspotter-http-shared-msw-handlers": "static-1.9653",
  "usage-tracker-session-replay": "static-1.4896",
  "amplitude-session-replay-browser": "static-1.57"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5397",
  "data-fetching-client": "/data-fetching-client/static-1.9549",
  "head-dlb": "/head-dlb/static-1.4884",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7883",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9655",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11316",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6343",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4660",
  "quartz": "/quartz/static-1.6831",
  "react-dlb": "/react-dlb/static-1.74",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5454",
  "UIComponents": "/UIComponents/static-3.8263",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
  "foundations-assets": "/foundations-assets/static-1.4713",
  "foundations-components": "/foundations-components/static-1.7662",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5145",
  "foundations-theming": "/foundations-theming/static-1.4283",
  "hub-http": "/hub-http/static-1.6092",
  "quartz-config": "/quartz-config/static-1.609",
  "quartz-core": "/quartz-core/static-1.6050",
  "quick-fetch": "/quick-fetch/static-1.3807",
  "raven": "/raven/static-3.5768",
  "react": "/react/static-7.182",
  "react-rhumb": "/react-rhumb/static-1.16525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11020",
  "usage-tracker": "/usage-tracker/static-1.7210",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7060",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3301",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3108",
  "quartz-webpack": "/quartz-webpack/static-1.3055",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.79",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2994",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "ts-schema": "/ts-schema/static-1.3974",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "react-utils": "/react-utils/static-2.5242",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4198",
  "rpc-client-utils": "/rpc-client-utils/static-1.4517",
  "HubStyle": "/HubStyle/static-2.11624",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4641",
  "cssUtils": "/cssUtils/static-1.764",
  "hs-story-utils": "/hs-story-utils/static-1.9300",
  "icons": "/icons/static-2.637",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.96",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3931",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1999",
  "react-aria": "/react-aria/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1424",
  "ui-fonts": "/ui-fonts/static-1.578",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.687",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2766",
  "foundations-theming-base": "/foundations-theming-base/static-1.3268",
  "stylex": "/stylex/static-1.29",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4547",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.506",
  "quartz-head": "/quartz-head/static-1.496",
  "quartz-i18n": "/quartz-i18n/static-1.506",
  "quartz-routing": "/quartz-routing/static-1.261",
  "quartz-test": "/quartz-test/static-1.506",
  "quartz-tracking": "/quartz-tracking/static-1.210",
  "usage-tracker-container": "/usage-tracker-container/static-1.7200",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3025",
  "chirp-fetch": "/chirp-fetch/static-1.1756",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.67",
  "sassPrefix": "/sassPrefix/static-1.153",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9653",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4896",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57"
}
};
